import React from "react";
import { Backdrop, CircularProgress, makeStyles } from "@material-ui/core";
import PropTypes from "prop-types";
const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}));

function LoadingSpinner({ isLoading }) {
  const classes = useStyles();

  return (
    <Backdrop className={classes.backdrop} open={isLoading}>
      <CircularProgress color='inherit' />
    </Backdrop>
  );
}

LoadingSpinner.prototype = {
  isLoading: PropTypes.bool.isRequired,
};

export default LoadingSpinner;
